
























import { Component, Prop, Vue } from "vue-property-decorator";
@Component({
  name: "qPopupTableHeader",
  components: {},
})
export default class QPopupTableHeader extends Vue {
  @Prop() public headers: any[];

  public clear(excludeId: string) {
    this.headers.map((header) => {
      if ("order" in header && header.id !== excludeId) {
        header.order = "";
      }
      return header;
    });
  }

  public sort(header): void {
    if ("order" in header) {
      if (header.order === "") {
        header.order = "desc";
      } else {
        header.order = header.order === "desc" ? "asc" : "desc";
      }
      this.clear(header.id);

      this.$emit("sort", { sort: header.id, direction: header.order });
    }
  }
}
